/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { sumBy } from 'es-toolkit';

import { convertESTtoUTC, convertFromUTCToEST } from '@/utils/date';

import { convertToFloat, trimObjectValues, valueToNumber, valueToString } from './format';

export const convertPreClaimsFilesToAPI = (files) => {
  const newFiles = [];
  files.forEach((fileDetails) => {
    if (fileDetails.fileList) {
      fileDetails.fileList.forEach((file) => {
        newFiles.push({
          claimKey: 0,
          dirtyFlag: file.dirtyFlag,
          documentType: valueToNumber(fileDetails.documentType),
          fileComments: valueToString(fileDetails.fileComments),
          //   description: "string",
          fileContent: valueToString(file.fileContent),
          fileName: valueToString(file.fileName),
          originalFileName: '',
          sequence: file.sequence,
        });
      });
    }
  });
  return newFiles;
};

export const LADCovertDatesToMomentType = (data) => {
  return {
    ...data,
    apDate: convertESTtoUTC(data?.apDate),
    checkDateToCustomer: convertESTtoUTC(data?.checkDateToCustomer),
    claimCloseDate: convertESTtoUTC(data?.claimCloseDate),
    claimMinCharge: Boolean(data.claimMinCharge === 'Y'),
    dateAck: convertESTtoUTC(data?.dateAck),
    dateFiled: convertESTtoUTC(data?.dateFiled),
    dateShipped: convertESTtoUTC(data?.dateShipped),
    disableDocumentation: Boolean(data.disableDocumentation === 'Y'),
    disableInspection: Boolean(data.disableInspection === 'Y'),
    disableInterest: Boolean(data.disableInterest === 'Y'),
    disableItems: Boolean(data.disableItems === 'Y'),
    disableLabor: Boolean(data.disableLabor === 'Y'),
    disableProration: Boolean(data.disableProration === 'Y'),
    invoiceDate: convertESTtoUTC(data?.invoiceDate),
  };
};

const normalizeLADItemsToAPI = (items) => {
  return items?.map((element) => ({
    ...element,
    smAmount: Number.isFinite(Number(element.smAmount)) ? Number(element.smAmount) : null,
  }));
};

export const LADCovertDatesFromMomentToAPIType = (data) => {
  return {
    ...data,
    apDate: data?.apDate ? convertFromUTCToEST(data.apDate) : null,
    checkDateToCustomer: data?.checkDateToCustomer ? convertFromUTCToEST(data.checkDateToCustomer) : null,
    claimCloseDate: data?.claimCloseDate ? convertFromUTCToEST(data.claimCloseDate) : null,
    claimItem: normalizeLADItemsToAPI(data.claimItem),
    claimMinCharge: data.claimMinCharge ? 'Y' : 'N',
    dateAck: data?.dateAck ? convertFromUTCToEST(data.dateAck) : null,
    dateFiled: data?.dateFiled ? convertFromUTCToEST(data.dateFiled) : null,
    dateShipped: data?.dateShipped ? convertFromUTCToEST(data.dateShipped) : null,
    disableDocumentation: data.disableDocumentation ? 'Y' : 'N',
    disableInspection: data.disableInspection ? 'Y' : 'N',
    disableInterest: data.disableInterest ? 'Y' : 'N',
    disableItems: data.disableItems ? 'Y' : 'N',
    disableLabor: data.disableLabor ? 'Y' : 'N',
    disableProration: data.disableProration ? 'Y' : 'N',
    invoiceDate: data?.invoiceDate ? convertFromUTCToEST(data.invoiceDate) : null,
  };
};

export const LDClaimsItemCalculation = (paramItem, paramCustomerSettings) => {
  const item = trimObjectValues(paramItem);
  const customerSettings = trimObjectValues(paramCustomerSettings);
  let totalWeight = 0;
  let itemQuantity = valueToNumber(item.itemQuantity);
  let itemUnitWeight = valueToNumber(item.itemUnitWeight);
  let value = valueToNumber(item.value);
  let totalValue = valueToNumber(item.totalValue);
  let smAmount = valueToNumber(item.smAmount);
  let productClaimAmount = valueToNumber(item.productClaimAmount);

  // Check for NULL's
  if (Number.isNaN(itemQuantity)) {
    itemQuantity = 0;
  }
  if (Number.isNaN(itemUnitWeight)) {
    itemUnitWeight = 0;
  }
  if (Number.isNaN(totalWeight)) {
    totalWeight = 0;
  }
  if (Number.isNaN(value)) {
    value = 0;
  }
  if (Number.isNaN(totalValue)) {
    totalValue = 0;
  }
  if (Number.isNaN(smAmount)) {
    smAmount = 0;
  }
  if (Number.isNaN(value)) {
    value = 0;
  }
  if (Number.isNaN(productClaimAmount)) {
    productClaimAmount = 0;
  }

  totalWeight = (itemQuantity * itemUnitWeight).toFixed(2);
  if (item.fullRelFlag === 'F') {
    totalValue = (itemQuantity * value).toFixed(2);
  } else if (item.fullRelFlag === 'R') {
    totalValue = (totalWeight * value).toFixed(2);
  }
  if (customerSettings.bypassClaimItemWeight !== 'Y') {
    item.totalWeight = totalWeight;
  }
  if (customerSettings.bypassClaimItemTotal !== 'Y') {
    item.totalValue = totalValue;
  }

  if (item.smFlag === 'SC') {
    if (item.smType === 'P') {
      productClaimAmount = totalValue - (totalValue * smAmount) / 100;
    } else {
      productClaimAmount = totalValue - smAmount;
    }
  } else if (item.smFlag === 'MD' || item.smFlag === 'RC') {
    if (item.smType === 'P') {
      productClaimAmount = (totalValue * smAmount) / 100;
    } else {
      productClaimAmount = smAmount;
    }
  } else {
    productClaimAmount = totalValue;
  }

  if (productClaimAmount == null || productClaimAmount === '') {
    productClaimAmount = 0;
  }
  item.productClaimAmount = Number.parseFloat(productClaimAmount).toFixed(2);
  return item;
};

export const LDClaimInspectionCostCalculation = (financialData, customerSettings) => {
  let lsRate;
  let lsCost;
  let lsHours;

  lsCost = Number.parseFloat(valueToNumber(financialData.inspectionCost));

  if (Number.isNaN(lsCost)) {
    lsCost = 0;
  }
  if (Number.isNaN(lsHours)) {
    lsHours = 0;
  }

  if (financialData.disableInspection) {
    return lsCost;
  }
  lsRate = Number.parseFloat(customerSettings?.inspectorRate);
  if (Number.isNaN(lsRate)) {
    lsRate = 0;
  }

  lsHours = Number.parseFloat(valueToNumber(financialData.inspectionHours));
  if (Number.isNaN(lsHours)) {
    lsHours = 0;
  }
  const inspectionCost = Number.parseFloat(lsRate * lsHours).toFixed(2);
  return inspectionCost;
};

export const LDClaimInterestCalculation = (financialData, customerSettings, detailsData, paramAlTotal) => {
  //al_total -> Total Claim
  let llDays = 0;
  let llMod = 0;
  let lsShipDate = '';
  let lsFileDate = '';
  let llClaimInterestRate;
  const llCompound = 30;
  let llMonths;
  let llNewtotal;
  let llInterest = valueToNumber(financialData.interestExpense);
  // let ld_ship_date;
  // let ld_file_date;
  // const ll_lastindex = 0;
  // const ll_year = 0;
  // let ls_year;
  const alTotal = valueToNumber(paramAlTotal);

  if (financialData.disableInterest) {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }

  lsShipDate = detailsData?.dateShipped;
  if (lsShipDate === '') {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }

  if (!lsShipDate?.isValid()) {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }

  // ls_ship_date = toFourCharYear(ls_ship_date);
  //ld_ship_date = Date.parse(ls_ship_date);

  // ls_ship_date = new Date(ls_ship_date);

  // ls_file_date = $("#Filed").val();
  lsFileDate = detailsData?.dateFiled;
  if (lsFileDate === '') {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }
  if (!lsFileDate?.isValid()) {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }
  //ls_file_date = toFourCharYear(ls_file_date);
  //ld_file_date = Date.parse(ls_file_date);

  // ls_file_date = new Date(ls_file_date);

  llClaimInterestRate = valueToNumber(customerSettings.claimInterestRate);
  if (llClaimInterestRate === '') {
    llClaimInterestRate = 0;
  }

  if (Number.isNaN(llClaimInterestRate) || llClaimInterestRate <= 0) {
    return { claimTotal: alTotal, interestExpense: llInterest };
  }

  llClaimInterestRate = llClaimInterestRate * 100;

  // ll_days = dateDiff(ls_ship_date, ls_file_date, "d") + 30;
  llDays = lsFileDate.diff(lsShipDate, 'days') + 30;
  llMod = llDays % llCompound;
  llMonths = llDays / llCompound;
  if (llMod >= 15) {
    llMonths++;
  }
  llMonths = Number.parseInt(llMonths, 10);

  llNewtotal = alTotal * (1 + (llMonths * llClaimInterestRate) / 100);

  /// ll_newtotal = al_total * (1 + (ll_months * ll_claim_interest_rate) / 100);
  llInterest = llNewtotal - alTotal;
  llInterest = llInterest.toFixed(2);

  //convert interest value before assigning to field if necessary
  // $("#InterestExpense").val(ll_interest);

  llNewtotal = llNewtotal.toFixed(2);
  return { claimTotal: llNewtotal, interestExpense: llInterest };
};

export const LDClaimLabourCostCalculation = (financialData, customerSettings) => {
  let lsRate;
  let lsCost = valueToNumber(financialData.laborCharge);
  let lsHours;

  if (Number.isNaN(lsCost)) {
    lsCost = 0;
  }
  if (Number.isNaN(lsHours)) {
    lsHours = 0;
  }

  if (financialData.disableLabor) {
    return lsCost;
  }
  lsRate = valueToNumber(customerSettings?.laborRate);
  if (Number.isNaN(lsRate)) {
    lsRate = 0;
  }

  lsHours = valueToNumber(financialData.laborHours);
  if (Number.isNaN(lsHours)) {
    lsHours = 0;
  }
  return Number.parseFloat(lsRate * lsHours).toFixed(2);
};

export const LDClaimProRatedCalculation = (financialData, items) => {
  const llWeight = valueToNumber(financialData.cargoShipmentWeight);
  const llChg = valueToNumber(financialData.claimFreightCharge);
  let llSumwgt = 0;
  let llFrt = 0;

  if (financialData.disableProration) {
    return 0;
  }

  if (Number.isNaN(llWeight) || llWeight <= 0) {
    // $("#Weight").val(0);
    return 0;
  }

  if (Number.isNaN(llChg) || llChg <= 0) {
    // $("#ProRated").val(0);
    return 0;
  }

  llFrt = llChg / llWeight;

  llSumwgt = sumBy(items || [], ({ totalWeight }) => valueToNumber(totalWeight));

  return (llFrt * llSumwgt).toFixed(2);
};

export const LDClaimFinancialCalculation = (financialData, customerSettings, items, detailsData) => {
  //Items variables
  let llSumTotalOfAll = 0;
  let llSumTotalWgt = 0;
  let llTotalSalvageAmount = 0;
  let llTotalMarkdownAmount = 0;
  let llTotalRepairAmount = 0;
  let llTotalProductClaimAmount = 0;
  let lsSMFlag;
  let lsSMType;
  let llTotalValue;
  let llItemUnitWeight;
  let llItemQuantity;
  let llSMAmount;

  //Claim variables
  let llDeductAmt;
  let llFrtChg;
  let llProrateAmt;
  let llCreditAmt;
  let llAddChg;
  let llAdminChg;
  let llTaxAmt;
  let llLaborChg;
  let llInspectCost;
  let llTotalShipmentWgt;
  let llClaimedFreight = 0;
  let llTotalClaimAmount = 0;
  let llTotalClaimAmt = 0;

  //Cust. Pref info
  let lsBypassClaimTotal;
  // let ls_bypass_claim_admin;

  let llThisitemtotal = 0;
  let llSalDedAmt = 0;

  if (Number(customerSettings?.customerKey) === 0) {
    if (!financialData.disableDocumentation) {
      financialData.claimAdminCharge = valueToNumber(customerSettings?.adminFees);
    }
  }

  if (!financialData.disableProration) {
    financialData.freightChargeClaimed = LDClaimProRatedCalculation(financialData, items);
  }
  //else
  //{
  // $('#ProRated').val(ll_prorate_amt.toFixed(2));
  //}

  if (!financialData.disableLabor) {
    financialData.laborCharge = LDClaimLabourCostCalculation(financialData, customerSettings);
  }

  if (!financialData.disableInspection) {
    financialData.inspectionCost = LDClaimInspectionCostCalculation(financialData, customerSettings);
  }

  //Get bypass info
  lsBypassClaimTotal = 'N';
  lsBypassClaimTotal = lsBypassClaimTotal.toUpperCase();
  //ls_bypass_claim_admin = ls_bypass_claim_admin.toUpperCase();

  // //Load up the Financials screen variables

  llDeductAmt = valueToNumber(financialData.claimDeductibleAmount);
  llFrtChg = valueToNumber(financialData.claimFreightCharge);
  llProrateAmt = valueToNumber(financialData.freightChargeClaimed);
  llCreditAmt = valueToNumber(financialData.claimCreditAmount);
  llAddChg = valueToNumber(financialData.claimAddCharge);
  llAdminChg = valueToNumber(financialData.claimAdminCharge);
  llTaxAmt = valueToNumber(financialData.claimTaxAmount);
  llLaborChg = valueToNumber(financialData.laborCharge);
  llInspectCost = valueToNumber(financialData.inspectionCost);
  llTotalShipmentWgt = valueToNumber(financialData.cargoShipmentWeight);

  //Check for nulls - if so, set to zero
  if (Number.isNaN(llDeductAmt) || llDeductAmt === '') {
    llDeductAmt = 0;
  }
  if (Number.isNaN(llFrtChg) || llFrtChg === '') {
    llFrtChg = 0;
  }
  if (Number.isNaN(llProrateAmt) || llProrateAmt === '') {
    llProrateAmt = 0;
  } //changed on 10/31/2005
  if (Number.isNaN(llCreditAmt) || llCreditAmt === '') {
    llCreditAmt = 0;
  }
  if (Number.isNaN(llAddChg) || llAddChg === '') {
    llAddChg = 0;
  }
  if (Number.isNaN(llAdminChg) || llAdminChg === '') {
    llAdminChg = 0;
  }
  if (Number.isNaN(llTaxAmt) || llTaxAmt === '') {
    llTaxAmt = 0;
  }
  if (Number.isNaN(llLaborChg) || llLaborChg === '') {
    llLaborChg = 0;
  }
  if (Number.isNaN(llInspectCost) || llInspectCost === '') {
    llInspectCost = 0;
  }
  if (Number.isNaN(llTotalShipmentWgt) || llTotalShipmentWgt === '') {
    llTotalShipmentWgt = 0;
  }

  //Use XPATH to walk thru the Items and calculate new totals
  // lobjClm = gobjClaim.gobjDataIsland.XMLDocument.childNodes(0).childNodes(0);
  // lobjThis = gobjItems.gobjDataIsland.XMLDocument.childNodes(0);

  items.forEach((paramElement) => {
    const element = trimObjectValues(paramElement);
    lsSMFlag = element.smFlag;
    lsSMFlag = lsSMFlag != null ? lsSMFlag.toUpperCase() : lsSMFlag;

    lsSMType = element.smType;
    lsSMType = lsSMType != null ? lsSMType.toUpperCase() : lsSMType;

    llTotalValue = Number.parseFloat(element.totalValue);

    llItemUnitWeight = Number.parseFloat(element.itemUnitWeight);

    llItemQuantity = Number.parseFloat(element.itemQuantity);

    llSMAmount = Number.parseFloat(element.smAmount);

    llThisitemtotal = Number.parseFloat(element.productClaimAmount);

    //Now, do the math
    //first time ll_sum_total_of_all appears ie initializing ll_sum_total_of_all
    llSumTotalOfAll = llSumTotalOfAll + llTotalValue;
    //ll_sum_total_wgt initialization
    llSumTotalWgt = llSumTotalWgt + llItemUnitWeight * llItemQuantity;

    if (lsSMFlag === 'MD') {
      llTotalMarkdownAmount = llTotalMarkdownAmount + llSMAmount;
    }

    if (lsSMFlag === 'RC') {
      //ll_total_repair_amount initialized
      llTotalRepairAmount = llTotalRepairAmount + llSMAmount;
    }

    if (lsSMFlag === 'SC') {
      if (lsSMType === 'P') {
        //initialization of ll_total_salvage_amount
        llTotalSalvageAmount = llTotalSalvageAmount + llTotalValue * (llSMAmount / 100);
      } else {
        llTotalSalvageAmount = llTotalSalvageAmount + (llTotalValue - llThisitemtotal);
      }

      //initialization of ll_sal_ded_amt
      //ll_total_value = value of Total Value field on Items screen
      //ll_thisitemtotal = value of Product Claim Amount field on Items screen
      //CONVERT value before assigning to field
      llSalDedAmt += llTotalValue - llThisitemtotal;
    }
    //ll_total_product_claim_amount initialization
    llTotalProductClaimAmount = llTotalProductClaimAmount + llThisitemtotal;
  });

  //START - added by acogent -----------------------------------------------
  //get the Markdown, salvage, repair and product amount if manual items is checked
  if (financialData.disableItems) {
    let salvage = valueToNumber(financialData.salvageAmount);
    if (salvage === '' || salvage == null || Number.isNaN(salvage)) {
      salvage = 0;
    }
    llTotalSalvageAmount = Number.parseFloat(salvage);

    let markdown = valueToNumber(financialData.markdownAmount);
    if (markdown === '' || markdown == null || Number.isNaN(markdown)) {
      markdown = 0;
    }
    llTotalMarkdownAmount = Number.parseFloat(markdown);

    let repair = valueToNumber(financialData.repairCostAmount);
    if (repair === '' || repair == null || Number.isNaN(repair)) {
      repair = 0;
    }

    llTotalRepairAmount = Number.parseFloat(repair);

    let product = valueToNumber(financialData.productClaimAmount);
    if (product === '' || product == null || Number.isNaN(product)) {
      product = 0;
    }
    llTotalProductClaimAmount = Number.parseFloat(product);

    ////add the Markdown, salvage and repair if manual items is checked
    llTotalClaimAmt = llTotalClaimAmt + llTotalSalvageAmount; //salvage amount field
    llTotalClaimAmt = llTotalClaimAmt + llTotalMarkdownAmount; //markdown amount field
    llTotalClaimAmt = llTotalClaimAmt + llTotalRepairAmount; //repair amount field
  }

  financialData.salvageAmount = Number.parseFloat(llTotalSalvageAmount).toFixed(2);

  financialData.markdownAmount = llTotalMarkdownAmount;

  financialData.repairCostAmount = llTotalRepairAmount;

  //END - added by acogent-------------------------------------------------

  //Now, use the items totals to update the Claim info.
  //ll_claimed_freight initialization
  //changed on 10/31/2005. Added a check to calculate pro-rated using ll_prorate_amt
  // when manual prorated is checked otherwise use ll_frt_chg
  // if (gl_calc_proration) {
  if (!financialData.disableProration) {
    if (llTotalShipmentWgt === 0) {
      llClaimedFreight = llFrtChg;
    }
    //ll_sum_total_wgt = item weight * item quantity for each item
    else {
      llClaimedFreight = (llSumTotalWgt / llTotalShipmentWgt) * llFrtChg;
    }
  } else {
    //for manual proration
    llClaimedFreight = llProrateAmt;
  }

  //Initialization of ll_total_claim_amt
  //ll_total_product_claim_amount = sum of Product Claim Amount of all items
  llTotalClaimAmt = llTotalProductClaimAmount - llDeductAmt; //Deductible field
  llTotalClaimAmt = llTotalClaimAmt - llCreditAmt; // Credit field
  llTotalClaimAmt = llTotalClaimAmt + llClaimedFreight;
  llTotalClaimAmt = llTotalClaimAmt + llAddChg; //Additional Cost field
  llTotalClaimAmt = llTotalClaimAmt + llAdminChg; //Documentation Cost field
  llTotalClaimAmt = llTotalClaimAmt + llTaxAmt; // Tax
  llTotalClaimAmt = llTotalClaimAmt + llLaborChg; //Labor Cost
  llTotalClaimAmt = llTotalClaimAmt + llInspectCost; //Inspection Cost

  //Check for Nulls...
  if (Number.isNaN(llTotalClaimAmt)) {
    llTotalClaimAmt = 0;
  }
  if (Number.isNaN(llSumTotalOfAll)) {
    llSumTotalOfAll = 0;
  }
  if (Number.isNaN(llClaimedFreight)) {
    llClaimedFreight = 0;
  }
  if (Number.isNaN(llTotalSalvageAmount)) {
    llTotalSalvageAmount = 0;
  }
  if (Number.isNaN(llTotalMarkdownAmount)) {
    llTotalMarkdownAmount = 0;
  }
  if (Number.isNaN(llTotalRepairAmount)) {
    llTotalRepairAmount = 0;
  }
  if (Number.isNaN(llSumTotalWgt)) {
    llSumTotalWgt = 0;
  }
  if (Number.isNaN(llSalDedAmt)) {
    llSalDedAmt = 0;
  }

  //Round all to 2 places
  llTotalClaimAmt = llTotalClaimAmt.toFixed(2);
  llSumTotalOfAll = llSumTotalOfAll.toFixed(2);
  llClaimedFreight = llClaimedFreight.toFixed(2);
  llTotalSalvageAmount = llTotalSalvageAmount.toFixed(2);
  llTotalMarkdownAmount = llTotalMarkdownAmount.toFixed(2);
  llTotalRepairAmount = llTotalRepairAmount.toFixed(2);
  llSumTotalWgt = llSumTotalWgt.toFixed(2);
  llSalDedAmt = llSalDedAmt.toFixed(2);

  ////Set values for each item
  if (!financialData.disableProration) {
    //$('#Weight').val(ll_sum_total_wgt);
    //$('#FreightCost').val(ll_claimed_freight);
    //$('#Deductible').val(ll_sal_ded_amt);
    //$('#MarkdownAmount').val(ll_total_markdown_amount);
    //$('#RepairCost').val(ll_total_repair_amount);
    financialData.productClaimAmount = llTotalProductClaimAmount;
  }

  ////Set value of Interest Expense field on Financials screen
  if (customerSettings.bypassClaimItemTotal !== 'Y') {
    if (!financialData.disableInterest) {
      const { claimTotal, interestExpense } = LDClaimInterestCalculation(
        financialData,
        customerSettings,
        detailsData,
        llTotalClaimAmt,
      );
      financialData.interestExpense = interestExpense;
      llTotalClaimAmount = claimTotal;
    } else {
      let interestValue = valueToNumber(financialData.interestExpense);
      if (interestValue === '' || interestValue == null || Number.isNaN(interestValue)) {
        interestValue = 0;
      }
      llTotalClaimAmount = Number.parseFloat(llTotalClaimAmt) + Number.parseFloat(interestValue);
    }

    llTotalClaimAmount = Number.parseFloat(llTotalClaimAmount).toFixed(2);
    financialData.claimTotal = llTotalClaimAmount;
  }

  // calculating documentation cost
  if (customerSettings.customerKey && Number(customerSettings.customerKey) !== 0) {
    if (!financialData.disableDocumentation) {
      const costFrom = valueToNumber(customerSettings.processingCostFrom);
      const costTo = valueToNumber(customerSettings.processingCostTo);
      const documentationCost =
        Number.parseFloat(llTotalClaimAmount) > Number.parseFloat(costFrom)
          ? Number.parseFloat(llTotalClaimAmount) < Number.parseFloat(costTo)
            ? Number.parseFloat(valueToNumber(customerSettings.adminFees))
            : 0
          : 0;

      financialData.claimAdminCharge = Number.parseFloat(documentationCost).toFixed(2); //set Documentation Cost on Financial Screen
    }
  }
  financialData.claimFreightCharge = convertToFloat(financialData.claimFreightCharge);
  financialData.interestExpense = convertToFloat(financialData.interestExpense);
  financialData.claimTaxAmount = convertToFloat(financialData.claimTaxAmount);
  financialData.claimAddCharge = convertToFloat(financialData.claimAddCharge);
  financialData.claimDeductibleAmount = convertToFloat(financialData.claimDeductibleAmount);
  financialData.claimCreditAmount = convertToFloat(financialData.claimCreditAmount);
  return financialData;
};
